module.exports = __webpack_public_path__ + "img/img0.ecddfbb4.jpg";